import axios from 'axios';
import store from './index';

const frfwProxy = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60 * 1000,
  withCredentials: false,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'content-type': 'application/json',
  },
});

frfwProxy.interceptors.request.use(
  (config) => {
    const token = store.state.frfwScan.token;
    if (token) {
      config.headers['authorization'] = token;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

frfwProxy.interceptors.response.use(
  function (response) {
    if (response.data.code !== -1) {
      return response.data;
    } else {
      return Promise.reject(new Error(response.data.msg));
    }
  },
  function (error) {
    return Promise.reject(error);
  }
);

export { frfwProxy };
